import { useMutation, useQueryClient } from '@tanstack/react-query';

import { supabase } from '@/integrations/supabase/client';

export const LOGIN_LOGS_QUERY_KEYS = {
  all: ['login_logs'] as const,
  byUser: (userId: string) => ['login_logs', 'user', userId] as const,
};

export const useInsertLoginLog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId }: { userId: string }) => {
      const { data, error } = await supabase
        .from('login_logs')
        .insert({ user_id: userId })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: LOGIN_LOGS_QUERY_KEYS.byUser(data.user_id) });
      void queryClient.invalidateQueries({ queryKey: LOGIN_LOGS_QUERY_KEYS.all });
    },
  });
};
